// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LinkedText } from './LinkedText';
import {
    LinkedTextFromJSON,
    LinkedTextFromJSONTyped,
    LinkedTextToJSON,
    LinkedTextToJSONTyped,
} from './LinkedText';

/**
 * Additional information on operating Vehicle. The information may be usable for passenger. Relates to `includeNoticeAttributes`.
 * @export
 * @interface Notice
 */
export interface Notice {
    /**
     * 2 letter key. **Derived from MERITS codes** for e.g. UIC Code 916-1 'reservation system code', though they are specified by SBB Data-Mgmt.<br>Be aware if **`type`=INFO, `advertised`=true** do not display the (rather confusing) `name`: Data resulting out of this MUST NOT be presented to enduser (for e.g. SBB channels), set wisely!
     * @type {string}
     * @memberof Notice
     */
    name: string;
    /**
     * 
     * @type {LinkedText}
     * @memberof Notice
     */
    text?: LinkedText;
    /**
     * Type of Notice. <br>x-extensible-enum: [ATTRIBUTE,INFO]
     * @type {string}
     * @memberof Notice
     */
    type: string;
    /**
     * A lower priority value means a higher importance (default=100, 0=UNKNOWN).
     * @type {number}
     * @memberof Notice
     */
    priority: number;
    /**
     * Relates to `ScheduledStop::routeIndex` where this note is valid from.
     * @type {number}
     * @memberof Notice
     */
    routeIndexFrom?: number;
    /**
     * Relates to `ScheduledStop::routeIndex` where this note is valid to.
     * @type {number}
     * @memberof Notice
     */
    routeIndexTo?: number;
    /**
     * Hint whether a passenger should see such a `Notice` being advertised (aka Transmodel NOTICE::canBeAdvertised).<br>Be aware if **false**: Data resulting out of this MUST NOT be presented to enduser (for e.g. SBB channels), set wisely!
     * @type {boolean}
     * @memberof Notice
     */
    advertised: boolean;
}

/**
 * Check if a given object implements the Notice interface.
 */
export function instanceOfNotice(value: object): value is Notice {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('advertised' in value) || value['advertised'] === undefined) return false;
    return true;
}

export function NoticeFromJSON(json: any): Notice {
    return NoticeFromJSONTyped(json, false);
}

export function NoticeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Notice {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'text': json['text'] == null ? undefined : LinkedTextFromJSON(json['text']),
        'type': json['type'],
        'priority': json['priority'],
        'routeIndexFrom': json['routeIndexFrom'] == null ? undefined : json['routeIndexFrom'],
        'routeIndexTo': json['routeIndexTo'] == null ? undefined : json['routeIndexTo'],
        'advertised': json['advertised'],
    };
}

  export function NoticeToJSON(json: any): Notice {
      return NoticeToJSONTyped(json, false);
  }

  export function NoticeToJSONTyped(value?: Notice | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'text': LinkedTextToJSON(value['text']),
        'type': value['type'],
        'priority': value['priority'],
        'routeIndexFrom': value['routeIndexFrom'],
        'routeIndexTo': value['routeIndexTo'],
        'advertised': value['advertised'],
    };
}

